import type {BindingSource} from '@packages/systems/dynamo/gateway';
import type {FauxBindingSource} from '@packages/systems/dynamo/utils/ParamPanelUtils';

export function getBindingSourceLabel(
  bindingSource: BindingSource | FauxBindingSource | null,
  contextBindingSource: BindingSource | null
) {
  const label = bindingSource ? bindingSource.label : '';
  const contextLabel = contextBindingSource ? contextBindingSource.label : null;
  return contextLabel ? `${label} (${contextLabel})` : label;
}
